import CryptoJS from "crypto-js";

// SHA256 hash and lowercase the value (Google requires lowercase before hashing)
export function hashSHA256(value) {
  if (!value) return "";
  return CryptoJS.SHA256(value.trim().toLowerCase()).toString();
}

// Format phone number to E.164
// Example: formatPhone("+1 (415) 555-2671") -> "+14155552671"
export function formatPhone(phone) {
  if (!phone) return "";
  return phone.replace(/\D/g, "").replace(/^0+/, "").replace(/^/, "+"); 
}
